import TemplatesTable from "@/components/templates/TemplatesTable";
import { useTemplates, useTemplateAdmin } from "@/hooks/useTemplates";

const Templates = () => {
  const { data: templates = [], isLoading } = useTemplates();
  const admin = useTemplateAdmin();

  return (
    <TemplatesTable
      items={templates}
      isLoading={isLoading}
      onUpdate={(id, data) => admin.update.mutateAsync({ id, data })}
      onDelete={(id) => admin.remove.mutateAsync(id)}
    />
  );
};

export default Templates;
